export function tooltipmap() {
  const dataLayer = $('#datalayer');
  const dataContent = $('.data-content');

  const getPageData = (url) => {
    var data = {
      'action': 'getPageData',
      url,
    };

    //$('body').addClass('overflow-hidden');

    $.ajax({
      type: 'POST',
      url: sanacorp.ajax_url,
      data: data,
      success: function(res) {
        //$('body').addClass('overflow-hidden');
        dataLayer.addClass('opened');
        dataContent.html(res);
      },
      error: function (request, status, error) {
        console.log(request);
        console.log(status);
        console.log(error);
      },
    });
  }

  $('a.maptooltip').click(function (e) {
    e.preventDefault();
    var url = $(this).attr('href');
    getPageData(url);
  });

  $('svg .mobile-group-toggler').click(function (e) {
    e.preventDefault();
    $('.mobile-group-layer').removeClass('show');
    var layer = $(this).next();
    layer.addClass('show');
  });

  $('svg .close-button').click(function (e) {
    e.preventDefault();
    var layer = $(this).parent();
    layer.removeClass('show');
  });

}



// WEBPACK FOOTER //
// ./scripts/components/tooltipmap.js